import React from "react";
import styles from "./index.module.scss";
import { Button, Icon } from "antd";
import { useAsyncFn, useInterval } from "react-use";
import { freshNumberCode } from "../../../../../service/signIn";
import usePromiseCallback from "../../../../../utils/usePromiseCallback";

interface Props {
    signInId: number;
    code: string;
    refreshTime: number;
}
const Index = ({ code, signInId, refreshTime }: Props) => {
    const [refreshStatus, callRefresh] = useAsyncFn(
        () => freshNumberCode(signInId),
        [signInId]
    );

    const onRefreshClick = usePromiseCallback(async function () {
        await callRefresh();
    });

    // 每隔若干秒刷新下状态
    useInterval(onRefreshClick, refreshTime * 1000);

    return (
        <div className={styles.root}>
            <div className={styles.num}>{refreshStatus?.value || code}</div>
            <Button
                className={styles.button}
                type="primary"
                ghost
                onClick={onRefreshClick}>
                <Icon type="sync" /> 更换数字码
            </Button>
        </div>
    );
};

export default Index;
